// action types
export const SET_ANSWERS = 'SET_ANSWERS';
export const FETCH_ANSWERS = 'FETCH_ANSWERS';
export const ADD_ANSWER_ITEM = 'ADD_ANSWER_ITEM';
export const ADD_DOCUMENT_FLAG = 'ADD_DOCUMENT_FLAG';
export const DELETE_ANSWER_ITEM = 'DELETE_ANSWER_ITEM';
export const SAVE_ANSWER_ITEM = 'SAVE_ANSWER_ITEM';
